<div id="stat-rows">
  <app-stat-row *ngFor="let stat of homePageHabitStats; let i = index" [stat]="stat" [index]="i + 1"></app-stat-row>
</div>
